/**
 * @flow
 * @relayHash 7c719d91f347978c05f47c4893cd4a22
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SegmentListItem_DeleteSegment_MutationVariables = {|
  input: {
    tripId?: ?string;
    segmentId?: ?string;
    clientMutationId?: ?string;
  };
|};

export type SegmentListItem_DeleteSegment_MutationResponse = {|
  +deleteSegment: ?{|
    +trip: ?{|
      +numSegments: ?number;
      +segments: ?$ReadOnlyArray<?{|
        +id: string;
      |}>;
    |};
  |};
|};
*/


/*
mutation SegmentListItem_DeleteSegment_Mutation(
  $input: DeleteSegmentInput!
) {
  deleteSegment(input: $input) {
    trip {
      numSegments
      segments {
        id
      }
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "DeleteSegmentInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SegmentListItem_DeleteSegment_Mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "DeleteSegmentInput!"
          }
        ],
        "concreteType": "DeleteSegmentPayload",
        "name": "deleteSegment",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "numSegments",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Segment",
                "name": "segments",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "SegmentListItem_DeleteSegment_Mutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "DeleteSegmentInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "SegmentListItem_DeleteSegment_Mutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "DeleteSegmentInput!"
          }
        ],
        "concreteType": "DeleteSegmentPayload",
        "name": "deleteSegment",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "numSegments",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Segment",
                "name": "segments",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation SegmentListItem_DeleteSegment_Mutation(\n  $input: DeleteSegmentInput!\n) {\n  deleteSegment(input: $input) {\n    trip {\n      numSegments\n      segments {\n        id\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// /src/components/Trips/__generated__/SegmentListItem_DeleteSegment_Mutation.graphql.js